import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AlarmScoreState {
  isSafeLoading: boolean
  isEffiLoading: boolean
  isReliLoading: boolean
  isNoneLoading: boolean
  error: string | undefined
  safetyData: any
  reliabilityData: any
  efficiencyData: any
  noneData: any
  httpStatus: number | undefined
}

export const initialState: AlarmScoreState = {
  isSafeLoading: false,
  isEffiLoading: false,
  isReliLoading: false,
  isNoneLoading: false,
  safetyData: undefined,
  reliabilityData: undefined,
  efficiencyData: undefined,
  noneData: undefined,
  error: undefined,
  httpStatus: 0
}

const assetAlarmSlice = createSlice({
  name: 'AssetAlarmSlice',
  initialState,
  reducers: {
    assetAlarmLoadingAction: (state, action: PayloadAction<{ label: string }>) => {
      return {
        ...state,
        isSafeLoading: action.payload.label === 'safety' ? true : state.isSafeLoading,
        isEffiLoading: action.payload.label === 'efficiency' ? true : state.isEffiLoading,
        isReliLoading: action.payload.label === 'reliability' ? true : state.isReliLoading,
        isNoneLoading: action.payload.label === 'none' ? true : state.isNoneLoading,
        error: undefined,
        httpStatus: 0
      }
    },
    assetAlarmUpdateAction: (state, action: PayloadAction<{ data: any, label: string, httpStatus: number }>) => {
      const { label, data, httpStatus } = action.payload
      return {
        ...state,
        error: undefined,
        httpStatus,
        isSafeLoading: label === 'safety' ? false : state.isSafeLoading,
        isEffiLoading: label === 'efficiency' ? false : state.isEffiLoading,
        isReliLoading: label === 'reliability' ? false : state.isReliLoading,
        isNoneLoading: label === 'none' ? false : state.isNoneLoading,
        safetyData: label === 'safety' ? data : state.safetyData,
        efficiencyData: label === 'efficiency' ? data : state.efficiencyData,
        reliabilityData: label === 'reliability' ? data : state.reliabilityData,
        noneData: label === 'none' ? data : state.noneData
      }
    },
    assetAlarmErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        ...state,
        isSafeLoading: false,
        isEffiLoading: false,
        isReliLoading: false,
        isNoneLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  assetAlarmLoadingAction,
  assetAlarmUpdateAction,
  assetAlarmErrorAction,
  reset
} = assetAlarmSlice.actions

export default assetAlarmSlice.reducer
